/**
 * RegExp that matches supported legacy URLs
 * - housinganywhere.com/images/$OWNER_TYPE/$OWNER_ID/$IMAGE_UUID.jpg
 * - housinganywhere.com/v2/images/$OWNER_TYPE/$OWNER_ID/$IMAGE_UUID.jpg
 */
export const LEGACY_URL_RE =
  /https:\/\/thumb\.(?:.*\.)?housinganywhere\.com(?:\/v2)?\/images\/(?:room|hauser|uni_logo|uni_photo)\/\d+\/[0-9a-f-]+.jpg/i;

/**
 * RegExp that matches Bosh URL (`https://$SOURCE/images/$OWNER_TYPE/$OWNER_ID/$SIZE/$IMAGE_UUID?t=$TRANSFORMATION&=$ROTATION`)
 */
export const BOSCH_URL_RE =
  /https:\/\/thumb\.(?:.*\.)?housinganywhere\.com\/images\/(?:listing|user|unilogo|uniphoto)\/\d+\/(?:default|raw|\d+x\d+)\/[0-9a-f-]+/i;

/**
 * RegExp that matches Imgix URL
 * - https://housinganywhere.imgix.net/$OWNER_TYPE/$OWNER_ID/$IMAGE_UUID.jpg
 * - https://housinganywhere-stage.imgix.net/$OWNER_TYPE/$OWNER_ID/$IMAGE_UUID.jpg
 */
export const IMGIX_URL_RE =
  /https:\/housinganywhere(.*)\.imgix\.net\/(?:room|hauser|uni_logo|uni_photo)\/\d+\/[0-9a-f-]+.jpg/i;

export enum ImageSize {
  default = '490x300',

  thumbnail = '200x200',

  // card/preview sizes with 3:2 aspect ratio
  xsmall = '360x240',
  small = '450x300',
  medium = '768x512',
  large = '1050x700',
  xlarge = '1860x1240',

  // fullscreen sizes
  fullscreenDesktopSmall = '1440x701',
  fullscreenDesktopMedium = '1920x881',
  fullscreenDesktopLarge = '2560x1241',
  fullscreenMobileSmall = '375x595',
  fullscreenMobileMedium = '414x664',
  fullscreenMobileLarge = '768x952',
}

export const ImgixSize = {
  default: { h: 490, w: 300 },

  thumbnail: { h: 200, w: 200 },

  // card/preview sizes with 3:2 aspect ratio
  xsmall: { h: 360, w: 240 },
  small: { h: 450, w: 300 },
  medium: { h: 768, w: 512 },
  large: { h: 1050, w: 700 },
  xlarge: { h: 1860, w: 1240 },

  // fullscreen sizes
  fullscreenDesktopSmall: { h: 1440, w: 701 },
  fullscreenDesktopMedium: { h: 1920, w: 881 },
  fullscreenDesktopLarge: { h: 2560, w: 1241 },
  fullscreenMobileSmall: { h: 375, w: 595 },
  fullscreenMobileMedium: { h: 414, w: 664 },
  fullscreenMobileLarge: { h: 768, w: 952 },
} as const;
